import React, {useEffect, useCallback,useState } from 'react';
import {
    required,
    minLength,
    maxLength,
    minValue,
    maxValue,
    number,
    regex,
    useNotify,
    email, Create,
    choices, Button, SelectInput, ReferenceInput, AutocompleteInput,
    Edit, SimpleForm, TextInput,
    DateInput, BooleanInput, NumberInput, FileInput, FileField,
    ImageInput, ImageField, SaveButton, Toolbar, DeleteButton,FormDataConsumer
} from 'react-admin';
import moment from 'moment';
import RichTextInput from 'ra-input-rich-text';
import { useForm } from 'react-final-form';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from '@material-ui/icons/Save';
import * as apiClient from "../../../common/apiClient";
import PopupCreateToolbar from "../../../common/PopupCreateToolbar";
import { makeStyles } from '@material-ui/core/styles';
import { useStyles } from "../../../formStyles";
import { toast } from "react-toastify";
const PremiumCreate = props => {
    const classes = useStyles({});
    const[tpPremiumAmt,setTpPremiumAmt]=useState(0);
    const[odPremiumAmt,setOdPremiumAmt]=useState(0);
    const[IsMultiPolicy,setIsMultiPolicy]=useState(null);
    const[IsinsurerId,setinsurerId]=useState(-1);
    const[IsLoaading,setLoading]=useState(false);
    const notify = useNotify();
    const[net,setNet]=useState(0);
    const initialValues = {
        ordId: props.ordId,
        sharePerc:0,

    }
    useEffect(() => {
        getOrderHeaderData();
    }, []); 
    const getOrderHeaderData = () => {
        apiClient.getOrderHeaderData(parseInt(props.ordId)).then(res => {
            //debugger
            if(res.isMultiPolicy==true)
            {
                setIsMultiPolicy(true);
            }
            else
            {
                setIsMultiPolicy(false);
            }
            setinsurerId(res.insurerId)
            
        }).catch(err => {
            console.log(err);
        });
    }
    const TwoDecimalPlaces = (value) => {
        
        if (isNaN(value))
        {
            value=0;
        }
        return Number(value).toFixed(2).valueOf();
    }
    const onAmountChangeAmt = (e, field) => {
        let inputVal = parseFloat(e.target.value);  
        let odPremiumAmt_In=odPremiumAmt
        let tpPremiumAmt_In=tpPremiumAmt
        if (field == "odPremiumAmt") {
            odPremiumAmt_In = inputVal;
            setOdPremiumAmt(inputVal);
        }
         
        if (field == "tpPremiumAmt") {
            tpPremiumAmt_In = inputVal;
            setTpPremiumAmt(inputVal)
        }
        if (isNaN(odPremiumAmt_In)) {
            odPremiumAmt_In = 0;
        }

        if (isNaN(tpPremiumAmt_In)) {
            tpPremiumAmt_In = 0;
        }
       setNet(odPremiumAmt_In+  tpPremiumAmt_In)


    }
    // toast.error("Validation issue : " + err, {
    //     position: "bottom-center",
    //     autoClose: 6000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     });
    //   console.log(err);
    // });
    const handleSubmit = async(formdata) => {
        if(parseInt(formdata.premiumTypeId)==136)
        {
            let SavedSharePerc=0;
            await apiClient.getSharePerc(parseInt(formdata.ordId)).then(res => {
             SavedSharePerc= parseFloat(formdata.sharePerc) +parseFloat(res[0].sharePerc)
                return
            }).catch(err => {
                
            });
            if(SavedSharePerc>100)
            {
                toast.error("Validation issue : Share Percent cannot be more than 100 % on overall", {
            position: "bottom-center",
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            });
            return;
          
            }
        }
        
        
        let m = moment(new Date());
        let data = {
            orderId: parseInt(formdata.ordId),
            insurerId: (formdata.insurerId) ? parseInt(formdata.insurerId) : IsinsurerId,
            policyDetailId: 0,//parseInt(formdata.policyDetailId),
            premiumTypeId: parseInt(formdata.premiumTypeId),
            odSumInsuredAmt: parseFloat(formdata.odSumInsuredAmt),
            odPremiumAmt: parseFloat(formdata.odPremiumAmt),
            tpSumInsuredAmt: parseFloat(formdata.tpSumInsuredAmt),
            tpPremiumAmt: parseFloat(formdata.tpPremiumAmt),
            netPremiumAmt:parseFloat(formdata.odPremiumAmt)+parseFloat(formdata.tpPremiumAmt),
            netSumInsuredAmt:parseFloat(formdata.odSumInsuredAmt)+parseFloat(formdata.tpSumInsuredAmt),
            sharePerc:parseFloat(formdata.sharePerc),
            remarks: formdata.remarks,
            policyNo: formdata.policyNo,
            isTaxable: formdata.isTaxable,
            createdBy: 0,
            modifyBy: 0,
            createdDate: m.toISOString(),
            modifyDate: m.toISOString(),


        }
        setLoading(true);
        apiClient.addEntiyRecord("order-premiums", data).then(res => {
            //console.log(res);
            props.onClose();
        }).catch(err => {
            setLoading(false);
            console.log(err);
        });

    }
    return (
        <Create {...props} >
            <SimpleForm
                onSubmit={handleSubmit}
                initialValues={initialValues}
                toolbar={!IsLoaading?<PopupCreateToolbar label="Save" onSave={handleSubmit} onClose={props.onClose} onCancel={props.onCancel} />:null}
                variant="outlined">
                    <div style={{ fontWeight: "bold", fontSize: "15px", width: "100%", borderBottom: "1px dashed lightgrey" }} >
                        Premium
                </div>
                <ReferenceInput label="Premium Type" fullWidth={true} link={false}  
                    perPage={5000} source="premiumTypeId"
                    filter={{ type: 'PRT' }}
                    reference="lookups" >
                    <SelectInput optionText="name" variant="outlined"  fullWidth={true} />
                </ReferenceInput>

                {/* <ReferenceInput label="Policy Detail" source="policyDetailId" reference="policy-masters" 
                formClassName={classes.last_inline_input} 
                fullWidth={true} link={false}>
                    <SelectInput optionText="name" validate={[required()]} />
                </ReferenceInput> */}

                {IsinsurerId>0 && IsMultiPolicy &&  IsMultiPolicy===true && <ReferenceInput perPage={250000} sort={{ field: 'name', order: 'ASC' }} validate={[required()]} 
                    filterToQuery={searchText => ({ 'name~like': searchText })}
                    label="Insurer" source="insurerId" reference="insurers" fullWidth={true} > 
                    <SelectInput optionText="name"  initialValue={IsinsurerId}/>
                </ReferenceInput>}
                {IsinsurerId>0 && IsMultiPolicy && IsMultiPolicy===false && 
                <ReferenceInput perPage={250000} sort={{ field: 'name', order: 'ASC' }} validate={[required()]} initialValue={IsinsurerId}
                    filterToQuery={searchText => ({ 'name~like': searchText })}
                    filter={{ id: parseInt(IsinsurerId) }}
                    label="Insurer" source="insurerId" reference="insurers" fullWidth={true} disabled={true}> 
                    <SelectInput optionText="name"  />
                </ReferenceInput> }


                <NumberInput label="OD Sum Insured" validate={[required()]} source="odSumInsuredAmt"
                 formClassName={classes.first_inline_input} 
                 fullWidth={true}
                  
                />
                <NumberInput label="OD Premium" validate={[required()]} source="odPremiumAmt"
                 formClassName={classes.last_inline_input} 
                 fullWidth={true} 
                  onChange={(e) => {
                    onAmountChangeAmt(e,"odPremiumAmt");
                }}
                />
                <NumberInput label="TP Sum Insured Amt" validate={[required()]} source="tpSumInsuredAmt"
                 formClassName={classes.first_inline_input} 
                 fullWidth={true} />
                <NumberInput label="TP Premium Amt" validate={[required()]} source="tpPremiumAmt"
                 formClassName={classes.last_inline_input} 
                 fullWidth={true} 
                  onChange={(e) => {
                    onAmountChangeAmt(e,"tpPremiumAmt");
                }}
                
                
                />
                
                <FormDataConsumer>
              {formDataProps => 
              //( setTPAID((formDataProps.formData.tpaId)) )
              <div>
              <div style={{fontWeight:"bold", fontSize:"15px",minWidth:"100%",borderBottom:"1px dashed lightgrey"}} >
                    <div style={{float:'right'}}>
                        Net Premium: {TwoDecimalPlaces(parseFloat(formDataProps.formData.odPremiumAmt)+parseFloat(formDataProps.formData.tpPremiumAmt))}
                </div>
                <br/>
                <div style={{fontWeight:"bold", fontSize:"15px",minWidth:"100%",borderBottom:"1px dashed lightgrey"}} >
                <div style={{float:'right'}}>
                        Net Sum Insured : {TwoDecimalPlaces(parseFloat(formDataProps.formData.odSumInsuredAmt)+parseFloat(formDataProps.formData.tpSumInsuredAmt))}
                        
                </div>
               </div>
               </div>
               </div>
              }
            </FormDataConsumer>

                
            <FormDataConsumer>
              {formDataProps => 
              //( setTPAID((formDataProps.formData.tpaId)) )
                formDataProps.formData.premiumTypeId==136  && IsMultiPolicy &&   <NumberInput variant="outlined" validate={[required(), number(), minValue(0),maxValue(100),maxLength(4)]} label="Share Perc" source="sharePerc"
                 
                fullWidth={true} 
                 onChange={(e) => {
                   onAmountChangeAmt(e,"sharePerc");
               }}/>
              }
            </FormDataConsumer>

            <FormDataConsumer>
              {formDataProps => 
              //( setTPAID((formDataProps.formData.tpaId)) )
                formDataProps.formData.premiumTypeId==136  && IsMultiPolicy &&   
                <TextInput label="Policy No" variant="outlined" source="policyNo" fullWidth={true} initialValue={""} />
              }
            </FormDataConsumer>
            
            <FormDataConsumer>
              {formDataProps => 
              //( setTPAID((formDataProps.formData.tpaId)) )
                formDataProps.formData.premiumTypeId==137  && 
                <TextInput label="Endorsement No"  variant="outlined" source="policyNo" fullWidth={true} initialValue={""} />
              }
            </FormDataConsumer>
            
                <TextInput label="Remarks" source="remarks" fullWidth={true} initialValue={""} />
                <BooleanInput variant="outlined" label="Is Taxable" source="isTaxable" fullWidth={true} initialValue={false} />
            </SimpleForm>
        </Create>
    );
}
export default PremiumCreate;